import { selectSelectedAccount, useAppSelector } from '@ibk/shared-config';
import { PermissionsDomains, PermissionsResources } from '@ibk/shared-types';
import { isValidCnpj } from '@ibk/shared-utils';
import { useRequiresAuthorization } from '../useRequiresAuthorization';
export const useInstructionsPermissioning = () => {
    const selectedAccount = useAppSelector(selectSelectedAccount);
    const canApprovePaymentLinks = useRequiresAuthorization(PermissionsDomains.INSTRUCTION, [
        PermissionsResources.INSTRUCTION_APPROVE_BANKSLIP,
        PermissionsResources.INSTRUCTION_APPROVE_PIX_OUT,
        PermissionsResources.INSTRUCTION_APPROVE_SCHEDULED_BANKSLIP,
        PermissionsResources.INSTRUCTION_APPROVE_SCHEDULED_PIX,
        PermissionsResources.INSTRUCTION_VIEW_PENDING_PAYMENTS,
    ]);
    const showApprovePaymentLinks = useRequiresAuthorization(undefined, undefined);
    return {
        canApprovePaymentLinks: canApprovePaymentLinks && isValidCnpj(selectedAccount?.documentNumber),
        showApprovePaymentLinks: showApprovePaymentLinks && isValidCnpj(selectedAccount?.documentNumber),
    };
};
